import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/index.scss'
import App from './App.tsx'
import { registerChunkLoadRecovery } from '@/lib/chunk-load-recovery'
import { maybeRedirectAuthCallbackToResetPassword } from '@/lib/auth-callback'

registerChunkLoadRecovery()
maybeRedirectAuthCallbackToResetPassword()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
